export default "__VITE_ASSET__BUlakTFF__"